import ajax from '../ajax.js';

/*
  select2 replacement using html datalist
*/

/**
 *
 * @param {object} options
 *  {
 *    dataURL: string, required
 *    element: html <input> element, required
 *    handler: function, required
  *  }
 */
export default function(options) {
  ajax(options.dataURL, {
    success: function(result) {
      const list = JSON.parse(result);
      const datalist = options.element.list;
      list.forEach(item => {
        let option = document.createElement('option');
        option.text = item.text;
        option.addEventListener('click', e => { console.log('clicked', e);});
        datalist.appendChild(option);
      });

      // options.element.addEventListener('change', e => { // 'input' better than 'change' in FF
      options.element.addEventListener('input', e => {
        let selectedName = e.target.value;
        let selectedId = null;
        list.forEach(item => {
          if (item.text === selectedName)
            selectedId = item.id;
        });
        options.handler(selectedId);
      });
    }
  });
}
